<template>
  <div>
    <Loading v-if="pageLoading" />
    <CRow v-else>
      <CCol lg="12">
        <CCard>
          <CCardBody>
            <CDataTable
              hover
              :items="tableItems"
              :fields="tableFields"
              table-filter
              itemps-per-page-select
              :items-per-page="10"
              sorter
              :sorterValue.sync="tableSorter"
              pagination
              v-if="!pageLoading"
            >
              <td slot="id" class="text-center" slot-scope="{ item }">
                <strong>{{ item.id }}</strong>
              </td>
              <td slot="summary" class="text-center" slot-scope="{ item }">
                <strong>{{ item.summary }}</strong>
              </td>
              <!-- <template #priority="{item}">
            <td class="text-center">
              <CBadge :color="getPriorityBadge(item.priority)">{{item.priority}}</CBadge>
            </td>
          </template>-->
              <!-- <td slot="assigned" slot-scope="{item}" class="text-center">
            <strong>{{item.assigned_to}}</strong>
          </td>-->
              <template #status="{ item }">
                <td class="text-right">
                  <CBadge class="p-2" :color="getBadge(item.status)">{{
                    item.status
                  }}</CBadge>
                </td>
              </template>
              <template #creation_time="{ item }">
                <td class="text-right">
                  <strong>{{
                    new Date(item.creation_time) | dateFormat("YY-MM-DD HH:mm")
                  }}</strong>
                </td>
              </template>
              <template #last_change_time="{ item }">
                <td class="text-right">
                  <strong>{{
                    new Date(item.last_change_time)
                      | dateFormat("YY-MM-DD HH:mm")
                  }}</strong>
                </td>
              </template>
              <template #show_details="{ item }">
                <td class="py-2">
                  <CButton
                    color="primary"
                    class="float-right"
                    v-on:click="detailOnClick(item.id, item.summary)"
                    >詳細</CButton
                  >
                </td>
              </template>
            </CDataTable>
            <!-- start_detailModal -->
          </CCardBody>
        </CCard>
        <div>
          <CModal
            :show.sync="detailModal"
            color="dark"
            :closeOnBackdrop="false"
            size="xl"
            :centered="true"
          >
            <template v-if="modalLoading">
              <Loading
                class="text-center"
                style="padding-top: 1rem; padding-bottom: 9rem"
              />
            </template>
            <template #body-wrapper v-if="!modalLoading">
              <img
                class="text-center"
                :src="loadingAnimation"
                v-if="modalLoading"
                style="padding: 2rem"
              />
              <div
                v-for="inquiryDetailContent in inquiryDetailContents"
                :key="inquiryDetailContent.index"
              >
                <CRow
                  v-for="(inquiryDetail, index) in inquiryDetailContent"
                  :key="inquiryDetail.id"
                >
                  <CCol lg="1"></CCol>
                  <CCol lg="10" style="padding-top: 2rem">
                    <CCard>
                      <CCardHeader>
                        {{ inquiryDetail.time }}
                      </CCardHeader>
                      <CCardBody>
                        {{ inquiryDetail.text }}
                      </CCardBody>
                      <CCardFooter>
                        <p v-if="index === 0">{{ userName }}</p>
                        <p v-else>リバティースタッフ</p>
                      </CCardFooter>
                    </CCard>
                  </CCol>
                  <CCol lg="1"></CCol>
                </CRow>
                <div
                  v-for="inquiryDetailContent in inquiryDetailContents"
                  :key="inquiryDetailContent.index"
                >
                  <CRow>
                    <CCol lg="1"></CCol>
                    <CCol lg="10">
                      <h4>お問合せ内容回答フォーム</h4>
                    </CCol>
                  </CRow>
                  <CForm class="member-info">
                    <Loading class="text-center" v-if="submitLoading" />
                    <CRow>
                      <CCol lg="1"></CCol>
                      <CCol lg="10">
                        <div
                          class="text-danger input-info"
                          v-if="!$v.application.comment.required"
                        >
                          お問合せ内容の回答は必須です
                        </div>
                        <div
                          class="text-danger input-info"
                          v-if="!$v.application.comment.maxLength"
                        >
                          1000文字までしか入力できません
                        </div>
                        <CTextarea
                          label="お問合せ内容の回答"
                          placeholder="お問合せ内容の回答を入力してください"
                          description="施設の料金は〇〇円です"
                          horizontal
                          rows="9"
                          required
                          maxLength
                          v-model="application.comment"
                        />
                        <CButton
                          color="success"
                          class="ml-0 px-5 text-center"
                          :disabled="$v.$invalid"
                          v-on:click="submitApplication"
                        >
                          送信
                        </CButton>
                      </CCol>
                      <CCol sm="1"></CCol>
                    </CRow>
                  </CForm>
                </div>
              </div>
            </template>

            <template #header>
              {{ inquiryDetailSummary }}
            </template>
            <template #footer>
              <CButton @click="detailModal = false" color="secondary"
                >閉じる</CButton
              >
            </template>
          </CModal>
        </div>
        <!-- end_detailModal -->
      </CCol>
    </CRow>

    <!-- start_completeModal -->
    <CModal
      :show.sync="completeModal"
      color="success"
      closeOnBackdrop
      :centered="true"
    >
      <p>回答を送信しました</p>
      <template #header> 送信完了 </template>
      <template #footer>
        <CButton @click="completeModal = false" color="secondary"
          >閉じる</CButton
        >
      </template>
    </CModal>
    <!-- end_completeModal -->

    <!-- start_LoginErrorModal -->
    <CModal
      :show.sync="GetInquiriesErrorModal"
      color="danger"
      closeOnBackdrop
      :centered="true"
    >
      <p>お問合せ内容が取得できません</p>
      <p>「閉じる」をクリックし、時間をおいて改めて送信してください</p>
      <template #header> 情報取得エラー </template>
      <template #footer>
        <CButton @click="GetInquiriesErrorModal = false" color="secondary"
          >閉じる</CButton
        >
      </template>
    </CModal>
    <!-- end_LoginErrorModal -->

    <!-- start_bugzillaLoginErrorModal -->
    <CModal
      :show.sync="bugzillaLoginErrorModal"
      color="danger"
      closeOnBackdrop
      :centered="true"
    >
      <p>お問合せ内容を表示できません</p>
      <p>「閉じる」をクリックし、時間をおいて改めて送信してください</p>
      <template #header> 情報取得エラー </template>
      <template #footer>
        <CButton @click="bugzillaLoginErrorModal = false" color="secondary"
          >閉じる</CButton
        >
      </template>
    </CModal>
    <!-- end_bugzillaLoginErrorModal -->
    <!-- start_commentCreateErrorModal -->
    <CModal
      :show.sync="commentCreateErrorModal"
      color="danger"
      closeOnBackdrop
      :centered="true"
    >
      <p>回答を送信できませんでした</p>
      <p>「閉じる」をクリックし、再度「送信」ボタンを押してください</p>
      <template #header> 送信エラー </template>
      <template #footer>
        <CButton @click="commentCreateErrorModal = false" color="secondary"
          >閉じる</CButton
        >
      </template>
    </CModal>
    <!-- end_commentCreateErrorModal -->
   

  </div>
</template>

<script>
import axios from "axios";
import { required, maxLength } from "vuelidate/lib/validators";
import inquiryData from "../assets/inquiryData.json";
import inquiryLoginUserData from "../assets/inquiryLoginUserData.json";
import inquiryRequestURL from "../assets/inquiryRequestURL.json";
import Loading from "../components/loading";

export default {
  name: "CustomerInquiryList",
  components: {
    Loading,
  },
  data() {
    return {
      userName: this.$keycloak.userName,
      commentCreator: inquiryLoginUserData.email,
      token: "",
      detailInquiryId: 0,
      inquiryDetailContents: [],
      inquiryDetailSummary: "",
      //モーダルの表示切り替え
      detailModal: false,
      completeModal: false,
      commentCreateErrorModal: false,
      GetInquiriesErrorModal: false,
      bugzillaLoginErrorModal: false,
      pageLoading: false,
      modalLoading: false,
      submitLoading: false,
      loadingAnimation: require("../assets/loadingAnimation.svg"),
      collapseDuration: 0,
      tableSorter: {
        column: "id",
        asc: false,
      },
      application: {
        comment: "",
      },
      tableItems: [],
      tableFields: [
        { key: "id", label: "お問合せ番号", _classes: "text-center bg-light" },
        { key: "summary", label: "概要", _classes: "text-center bg-light" },
        // { key: "priority", label: "優先度", _classes: "text-center" },
        // { key: "assigned_to", label: "担当者", _classes: "text-left" },
        { key: "status", label: "ステータス", _classes: "text-right bg-light" },
        { key: "creation_time", label: "登録日時", _classes: "text-right bg-light" },
        {
          key: "last_change_time",
          label: "最終更新日時",
          _classes: "text-right bg-light",
        },
        {
          key: "show_details",
          _classes: " bg-light",
          label: "",
          _style: "width:8%",
          sorter: false,
          filter: false,
        },
      ],
       
    };
  },
  //入力項目にvalidation
  validations: {
    application: {
      comment: {
        required,
        maxLength: maxLength(1000),
      },
    },
  },
  beforeMount() {
    //console.log("ページ更新01");
    this.getInquiries();
  },
  methods: {
    //入力フォームリセット
    resetInput: function () {
      this.application.comment = "";
    },
    submitApplication: function () {
      //ローディング表示
      this.submitLoading = true;
      //bugzillaに用意されている値を用意
      var inquiryInfo = {
        comment: "",
        is_private: false,
        is_markdown: true,
      };
      //入力した内容をbugzillaに用意された値に入力情報を代入
      inquiryInfo.comment = this.application.comment;

      //bugzillaにログインする
      //bugzillaアカウント情報
      var email = inquiryLoginUserData.email;
      var password = inquiryLoginUserData.password;
      //var password = "errorPassword";
      // //tokenを入れる変数用意
      var token = "";
      // var userid = "";

      //ログインリクエスト
      var bugzillaLoginRequest =
        inquiryRequestURL.URL +
        "/rest/login?login=" +
        email +
        "&password=" +
        password;
      axios
        .get(bugzillaLoginRequest)
        .then((resp) => {
          //bugzillaログイン成功
          token = resp.data.token;

          //送信エラー表示用トークン
          //token = "errorToken";
          //userid = resp.data.id;
          console.log("LoginSuccess");
          //Bugzillaに回答送信リクエスト
          var bugzillaCommentRequest =
            inquiryRequestURL.URL +
            "/rest/bug/" +
            this.detailInquiryId +
            "/comment?token=" +
            token;
          axios
            .post(bugzillaCommentRequest, inquiryInfo)
            .then((resp) => {
              //bugzilla回答送信成功
              // const bugid = resp.data.id;

              console.log("CommentCreateSuccess");
              console.log(resp);

              //ローディング非表示
              this.submitLoading = false;

              //詳細モーダル閉じる
              this.detailModal = false;

              //完了ダイアログ表示
              this.completeModal = true;
            })
            .catch((err) => {
               

              //bugzilla回答送信失敗
              this.commentCreateErrorModal = true;

              //ローディング非表示
              this.submitLoading = false;

              console.log("CommentCreateFailed");
              console.log(err);
            });
        })
        .catch((err) => {
           

          //bugzillaログイン失敗
          this.LoginErrorModal = true;

          //ローディング非表示
          this.submitLoading = false;

          console.log("LoginFailed");
          console.log(err);
        });
    },
    detailOnClick(InquiryId, inquirySummary) {
      //ローディングアニメーション表示
      this.modalLoading = true;

      //入力フォームリセット
      this.resetInput();

      //モーダル表示前に中のデータクリア
      this.inquiryDetailContents = [];

      //モーダル表示
      this.detailModal = true;

      //詳細表示するお問合せのIDを他で扱えるように変数に格納
      this.detailInquiryId = InquiryId;

      //概要の取得
      this.inquiryDetailSummary = inquirySummary;

      //console.log(this.inquiryDetailSummary);
      //個別の問合せ取得
      var bugzillaGetBugDetailRequest =
        inquiryRequestURL.URL +
        "/rest/bug/" +
        InquiryId +
        "/comment" +
        "?token=" +
        this.token;
      axios
        .get(bugzillaGetBugDetailRequest)
        .then((resp) => {
          // console.log(resp);
          // console.log(resp.data);
          // console.log(resp.data.bugs);
          // const bugs = resp.data.bugs;
          //コメント情報取得
          //console.log(resp.data.bugs[InquiryId]);
          this.inquiryDetailContents = resp.data.bugs[InquiryId];

          //ローディングアニメーション非表示
          this.modalLoading = false;
        })
        .catch((err) => {
            

          console.log(err);
        });
    },
    getInquiries: function () {
      //ローディングアニメーション表示
      this.pageLoading = true;
      //bugzillaにログインする
      //bugzillaアカウント情報
      var email = inquiryLoginUserData.email;
      var password = inquiryLoginUserData.password;
      //var password = "errorPassword";
      //tokenを入れる変数用意
      // var token = "";
      //var userid = "";

      //ログインリクエスト
      var bugzillaLoginRequest =
        inquiryRequestURL.URL +
        "/rest/login?login=" +
        email +
        "&password=" +
        password;
      axios
        .get(bugzillaLoginRequest)
        .then((resp) => {
          //ログイン成功
          this.token = resp.data.token;

          console.log("LoginSuccess");

          //一般ユーザーのお問合せを取得
          var bugzillaLoginRequest =
            inquiryRequestURL.URL +
            "/rest/bug?product=リバティーリゾート会員システム&component=ユーザー問合せ" +
            "&status=" +
            inquiryData.status[0] +
            "&status=" +
            inquiryData.status[1] +
            "&status=" +
            inquiryData.status[2] +
            "&status=" +
            inquiryData.status[3];

          axios
            .get(bugzillaLoginRequest)
            .then((resp) => {
              console.log("getInquiriesSuccess");
              this.tableItems = resp.data.bugs;

              //ローディングアニメーション非表示
              this.pageLoading = false;
            })
            .catch((err) => {
               

              this.GetInquiriesErrorModal = true;
              console.log("getInquiriesFailed");
              console.log(err);

              //ローディングアニメーション非表示
              this.pageLoading = false;
            })
            .catch((err) => {
               

              this.GetInquiriesErrorModal = true;
              console.log("getInquiriesFailed");
              console.log(err);

              //ローディングアニメーション非表示
              this.pageLoading = false;
            });
        })
        .catch((err) => {
            

          //ログイン失敗
          this.bugzillaLoginErrorModal = true;
          console.log(err);
          console.log("LoginFailed");

          //ローディングアニメーション非表示
          this.pageLoading = false;
        });
    },

    // getPriorityBadge(priority) {
    //   switch (priority) {
    //     case "不急":
    //       return "success";
    //     case "低順位":
    //       return "secondary";
    //     case "普通":
    //       return "info";
    //     case "緊急":
    //       return "warning";
    //     case "至急":
    //       return "danger";
    //     default:
    //       "primary";
    //   }
    // },
    getBadge(status) {
      switch (status) {
        case inquiryData.status[0]:
          return "danger";

        case inquiryData.status[1]:
          return "warning";

        case inquiryData.status[2]:
          return "warning";

        case inquiryData.status[3]:
          return "warning";

        case inquiryData.status[4]:
          return "success";

        case inquiryData.status[5]:
          return "secondary";
        default:
          "info";
      }
    },
  },
};
</script>
